import { combineReducers } from 'redux';
import { authReducer } from './modules/auth/store/reducer';
import { propConfigReducer } from './modules/propConfig/store/reducer';
import { sysStoreReducer } from './modules/sysStore/store/reducer';
import { IntFileReducer } from './modules/intFile/store/reducer';
import { IntFileLogReducer } from './modules/intFileLog/store/reducer';
import { FileUploadReducer } from './modules/fileUpload/store/reducer';
import { posJournalReducer } from './modules/posJournal/store/reducer';
import toastReducer from './utils/toastReducer';
import { MediaManagementReducer } from './modules/mediaManagement/store/reducer';
import { UsersReducer } from './modules/users/store/reducer';
import { StoreItemsReducer } from './modules/inventory/store/reducer';
import { SysEventsReducer } from './modules/sysEvents/store/reducer';
import { SysApiLogsReducer } from './modules/sysApilog/store/reducer';
import { DevOpsToolReducer } from './modules/devopsTool/store/reducer';
import { IntOutBoundFileReducer } from './modules/intOutboundFile/store/reducer';
import { sysErrorCodeReducer } from './modules/sysErrorCode/store/reducer';
import { sysAppLoggerReducer } from './modules/sysAppLogger/store/reducer';
import { DashboardStatsReducer } from './modules/Dashboard/store/reducer';
import uiReducer from './utils/uiReducer';  // Use default import
import { RolesReducer } from './modules/roles/store/reducer';
import { StoreSysIdReducer } from './modules/storeSystemIdConfig/store/reducer';


const rootReducer = combineReducers({
    auth: authReducer,
    propconfig: propConfigReducer,
    sysStore: sysStoreReducer,
    intFile: IntFileReducer,
    intFileLog: IntFileLogReducer,
    fileUpload: FileUploadReducer,
    posJournal: posJournalReducer,
    toast: toastReducer,
    media: MediaManagementReducer,
    user: UsersReducer,
    storeItems: StoreItemsReducer,
    sysApilogs:SysApiLogsReducer,
    sysEvents: SysEventsReducer,
    devOpsTool: DevOpsToolReducer,
    intOutBoundFile: IntOutBoundFileReducer,
    sysErrorCodes: sysErrorCodeReducer,
    appLogger: sysAppLoggerReducer,
    dashboard: DashboardStatsReducer,
    ui: uiReducer,
    roles: RolesReducer,
    storeSysId: StoreSysIdReducer
    // Add other reducers here
});

export default rootReducer;
